<template>
	<div class="lt">
		<div v-if="currentStep === 1" class="lt__step-1">
			<section class="lt__step-1__ex-list">
				<h2>제외된 인원</h2>
				<span v-if="exclusive.length === 0" class="lt__step-1__nothing"
					>없음</span
				>
				<span
					v-else
					v-for="(member, index) in exclusive"
					class="lt__ex-list__ex-user"
				>
					{{ member.real_name }}
					<i class="fa fas fa-plus" @click="add(index)"></i>
				</span>
			</section>

			<section class="lt__step__user-list">
				<h2>선택된 인원</h2>
				<div>
					<label>
						<input
							type="text"
							@input="searching"
							v-model="search"
							placeholder="사원 검색"
						/>
					</label>
				</div>
				<span v-if="members.length === 0" class="lt__step-1__nothing"
					>없음</span
				>
				<span
					v-else
					v-for="(member, index) in members"
					class="lt__user-list__user"
					:class="{ 'lt__user-list__user--bold': member.bold }"
				>
					{{ member.real_name }}
					<i class="fa fas fa-times" @click="remove(index)"></i>
				</span>
			</section>

			<button class="lt__step-1__shuffle" @click="grouping">
				선택된 인원으로 그룹 나누기
			</button>
		</div>

		<div v-else-if="currentStep === 2" class="lt__step-2">
			<table class="lt__step-2__table">
				<tr v-for="(group, index) in chunked">
					<td>
						{{ index + 1 }} <br />
						({{ group.length }}명)
					</td>
					<td>
						<span
							v-for="member in group"
							class="lt__user-list__user"
						>
							{{ member.real_name }}
						</span>
					</td>
				</tr>
			</table>

			<label>
				<input
					type="text"
					v-model="slackMessage"
					placeholder="함께 보낼 메세지(ex: 런치 투게더!)"
				/>
			</label>

			<div class="lt__step-2__btn-wrapper">
				<button class="lt__step-2__open" @click="openConversation">
					슬랙으로 전송하기
				</button>
				<button class="lt__step-2__cancel" @click="cancel">
					이전 단계로
				</button>
			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash';

	const token = 'xoxb-141244727060-769267913557-4DErA6kpuu1R3r6kdR4qekjx';
	const stdNumbers = [4, 5, 6];

	export default {
		name: 'LunchTogether',
		data() {
			return {
				currentStep: 1,
				members: [],
				exclusive: [],
				chunked: [],
				search: '',
				slackMessage: '',
			};
		},
		mounted() {
			this.$store.commit('toggleSpinner', false);
			this.getUsers();
		},
		methods: {
			slack(method, api, data = {}) {
				const form = new FormData();
				const array = [];

				if (method.toLowerCase() === 'get') {
					_.each(data, (value, key) => {
						array.push(`${key}=${value}`);
					});

					return this.$axiosSlack[method](
						`${api}?${array.join('&')}`
					);
				} else {
					_.each(data, (value, key) => {
						form.append(key, value);
					});

					return this.$axiosSlack[method](api, form);
				}
			},
			getUsers() {
				this.slack('get', 'users.list', { token })
					.then(({ data }) => {
						this.members = data.members;
						this.members = _.filter(this.members, member => {
							return (
								member.deleted === false &&
								member.tz === 'Asia/Seoul'
							);
						});
						this.members = _.orderBy(this.members, [
							'real_name',
							'desc',
						]);
						_.each(this.members, member => {
							member.bold = false;
						});
					})
					.catch(({ response }) => {
						console.error(response);
					});
			},
			add(index) {
				const added = this.exclusive.splice(index, 1);
				this.members.push(added.pop());
			},
			remove(index) {
				const removed = this.members.splice(index, 1);
				this.exclusive.push(removed.pop());
			},
			searching() {
				_.each(this.members, member => {
					if (this.search.trim().length > 0) {
						member.bold =
							member.real_name
								.toLowerCase()
								.replace(/\s/g, '')
								.indexOf(this.search.trim()) > -1;
					} else {
						member.bold = false;
					}
				});
			},
			shuffle() {
				this.members = _.shuffle(this.members);
			},
			chunk() {
				let number = 0;

				_.each(stdNumbers, stdNumber => {
					if (this.members.length % stdNumber === 0) {
						number = stdNumber;
					}
				});

				if (number === 0) {
					let remain = 0;

					_.each(stdNumbers, stdNumber => {
						if (remain < this.members.length % stdNumber) {
							number = stdNumber;
							remain = this.members.length % stdNumber;
						}
					});
				}

				this.chunked = _.chunk(this.members, number);
			},
			grouping() {
				this.shuffle();
				this.chunk();
				this.currentStep++;
			},
			openConversation() {
				let count = 0;
				let message = this.slackMessage;

				if (message.length === 0) {
					message = '런치 투게더';
				}

				message += `(Shuffled by ${this.$store.state.login.name}(${this.$store.state.login.idRegister}))`;

				_.each(this.chunked, group => {
					const users = [];

					_.each(group, user => {
						users.push(user.id);
					});

					this.$store.commit('toggleSpinner', true);
					this.slack('post', 'conversations.open', {
						token,
						users: users.join(','),
					})
						.then(({ data }) => {
							this.slack('post', 'chat.postMessage', {
								token,
								channel: data.channel.id,
								text: message,
							})
								.then(({ data }) => {
									this.$store.commit('toggleSpinner', false);
									count++;

									if (count === this.chunked.length) {
										alert(
											'슬랙으로 전송이 완료되었습니다.'
										);
									}
								})
								.catch(({ response }) => {
									this.$store.commit('toggleSpinner', false);
									alert(
										'전송 중 오류가 발생했습니다\n관리자에게 문의해 주세요'
									);
									console.error(response);
								});
						})
						.catch(({ response }) => {
							this.$store.commit('toggleSpinner', false);
							alert(
								'전송 중 오류가 발생했습니다\n관리자에게 문의해 주세요'
							);
							console.error(response);
						});
				});
			},
			cancel() {
				this.currentStep--;
			},
		},
	};
</script>
<style lang="scss" scoped>
	h2 {
		font-size: 1.5em;
		padding: 0.5em;
		background-color: #f4f7fa;
		margin: 0.5em 0;
		border: 1px solid #657088;
		border-right: 0;
		border-left: 0;
	}

	.lt__step-1__nothing {
		display: inline-block;
		font-size: 1.25em;
		padding: 0.5em;
	}

	.lt__step-1__user-list__ex-list {
		display: inline-block;
		margin: 0.25em 0.25em;
		padding: 0.5em;
		background: #f4f7fa;
		border: 1px solid #657088;
		border-radius: 1em;
		font-size: 16px;
		color: #657088;
	}

	.lt__user-list__user,
	.lt__ex-list__ex-user {
		display: inline-block;
		margin: 0.25em 0.25em;
		padding: 0.5em;
		background: #f4f7fa;
		border: 1px solid #657088;
		border-radius: 1em;
		font-size: 16px;
		color: #657088;
	}

	.lt__user-list__user--bold {
		border: 2px solid orange;
	}

	.lt__ex-list__ex-user {
		background: orange;
		font-weight: bold;
		color: #fff;
	}

	.fa-plus {
		border: 1px solid #657088;
		border-radius: 50%;
		width: 1.25em;
		height: 1.25em;
		font-size: 0.75em;
		background: #657088;
		color: #fff;
		cursor: pointer;
		line-height: 14px;
	}

	.fa-times {
		border: 1px solid;
		border-radius: 50%;
		width: 1.25em;
		height: 1.25em;
		font-size: 0.75em;
		background: orange;
		cursor: pointer;
	}

	.lt__step-1__shuffle {
		display: block;
		margin: 2em auto;
		padding: 8px 16px;
		background-color: #657088;
		border: solid 1px #acaeb4;
		border-radius: 26px;
		color: #fff;
		font-size: 1.25em;
		line-height: 30px;
		font-weight: bold;
	}

	.lt__step-2 {
		table {
			tr {
				border-top: 1px solid #acaeb4;
				border-bottom: 1px solid #acaeb4;

				td:first-child {
					font-size: 1.25em;
					vertical-align: middle;
					background-color: #f4f7fa;
					color: #657088;
					font-weight: bold;
					text-align: center;
				}
			}

			td {
				padding: 1em;
			}
		}
	}

	.lt__step-2__table {
		margin-bottom: 1em;
	}

	.lt__step-2__btn-wrapper {
		text-align: center;
	}

	.lt__step-2__open {
		margin: 2em auto;
		padding: 8px 16px;
		background-color: #657088;
		border: solid 1px #acaeb4;
		border-radius: 26px;
		color: #fff;
		font-size: 1.25em;
		line-height: 30px;
		font-weight: bold;
	}

	.lt__step-2__cancel {
		margin: 2em auto;
		padding: 8px 16px;
		background-color: transparent;
		border: solid 1px $red;
		border-radius: 26px;
		color: $red;
		font-size: 1.25em;
		line-height: 30px;
		font-weight: bold;
	}
</style>
